import definedFunction from './definedFunction'
import buildResults from './buildResults'

/**
 * @namespace util
 */
export {definedFunction, buildResults}



// WEBPACK FOOTER //
// ./src/util/index.js